import { createRouter, createWebHistory } from "vue-router";
import GraphView from "@/views/GraphView.vue";
import LoginView from "@/views/LoginView.vue";
import HomeView from "@/views/HomeView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    meta: { requiresAuth: true },
    component: HomeView,
  },
  {
    path: "/login",
    name: "login",
    component: LoginView,
  },
  {
    path: "/graph",
    name: "Graph",
    meta: { requiresAuth: true },
    component: GraphView,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const isCloudRun =
    window.location.hostname.includes("run.app") ||
    window.location.hostname.includes("biocortex.bio") ||
    window.location.hostname.includes("biocortex.app");
  const isAuthenticated = localStorage.getItem("bcx_auth_token");
  if (isCloudRun && to.meta.requiresAuth && !isAuthenticated) {
    next("/login");
  } else {
    next();
  }
});

export default router;
